import axios from 'axios';

const acceptPolicy = () => {
  return axios.put('voice/settings/accept');
};

export { acceptPolicy };
